import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '../../shared/pipes/pipes.module';
import { SharedModule } from '../../shared/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { PaymentActionsListComponent } from './payment-actions-list/payment-actions-list.component';
import { PaymentActionsRoutingModule } from './payment-actions-routing.module';
import { PaymentActionComponent } from './payment-action/payment-action.component';
import { PaymentActionsUrlComponent } from './payment-actions-url/payment-actions-url.component';

@NgModule({
  imports: [
    CommonModule,
    PaymentActionsRoutingModule,
    NgxPaginationModule,
    SharedModule,
    PipesModule
  ],
  declarations: [
    PaymentActionsListComponent,
    PaymentActionComponent,
    PaymentActionsUrlComponent
  ],
  entryComponents: [
    PaymentActionComponent
  ]
})
export class PaymentActionsModule {
}
